// Hari K : 11-09-2023 LogOut confirm modal-start
import { memo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../redux/actions/auth";
import { handleModal } from "../../redux/actions/modals";
import { LOCAL_STORAGE_KEYS } from "../../utils/global_variables";

const LogOutConfirmationModal = () => {

    const modals = useSelector(state => state?.modals?.modals);
    const dispatch = useDispatch();

    const handleConfirm = () => {
        dispatch(userLogout()).then(() => {
            // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
            localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
            // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --End
            window.location.replace('/');
        }).catch(() => {
            // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
            localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
            // Ameersha N : 28-11-2023 : BT-116461 Breeze - Addendum and Notices --End
            window.location.replace('/');
        });
    };

    const handleCancelModal = () => {
        dispatch(handleModal([{ 'USER_LOG_OUT_CONFIRMATION_MODAL': false }]));
    };

    return (
        <BzModal size='sm' centered show={modals['USER_LOG_OUT_CONFIRMATION_MODAL']} onHide={handleCancelModal} onExiting={handleCancelModal} className='modal-breeze'>
            <BzModalHeader className='modaltabs-header'> {/*Hari P: 29-11-2023 class removed class for alignment*/}
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Logout</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleCancelModal}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>Are you sure you want to logout?</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline me-3' onClick={handleCancelModal}>Cancel</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' autoFocus onClick={handleConfirm}>Confirm</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
};

export default memo(LogOutConfirmationModal);

// Hari K : 11-09-2023 LogOut confirm modal -end